import $ from 'jquery';
import 'select2';

export default function initSelect2() {
  $(".js-example-placeholder-single").each(function () {
    let parent = $(this).closest('.filter-selected')
    $(this).select2({
      allowClear: true,
      dropdownParent: parent,
    });
  })
}